// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"45e0b9b9","591":"b6f29a76"}[chunkId] + ".chunk.css";
};